(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("map-skirts", [], factory);
	else if(typeof exports === 'object')
		exports["map-skirts"] = factory();
	else
		root["map-skirts"] = factory();
})(self, function() {
return 